/**
 * 사용자 목록 요청의 쿼리스트링을 만든다.
 *
 * ## 왜 셀렉터 안이 아니라 여기인가
 *
 * 2026-09-22 에 **등급 필터가 아무것도 안 하고 있었다.** 드롭다운도 있고 atom 도
 * 있었는데 셀렉터가 그 atom 을 읽지 않아서, 바꿔도 요청이 안 나가고 나가도
 * `level` 이 안 실렸다. 실측으로 확인했다 — 드롭다운을 «엘리트» 로 바꿨을 때
 * `GET /api/users` 는 **한 건도 나가지 않았고** 목록은 7명 그대로였다.
 * 같은 실수가 정렬에서 한 번(`ab64c8a`), 필터에서 한 번(`a715116`) 났다.
 *
 * 주석으로는 못 막는다. **타입으로 막는다.** 아래 `AdminUsersQueryInput` 의 필드는
 * 전부 필수다. 셀렉터가 하나라도 `get()` 하는 것을 잊으면 `tsc` 가 거기서 멈춘다.
 * 필터를 새로 붙이는 사람은 이 타입에 필드를 더하게 되고, 그 순간 컴파일이 깨져서
 * 배선을 빠뜨릴 수가 없다.
 *
 * 순수 함수라 recoil 없이 테스트된다.
 */
export type AdminUsersQueryInput = {
  /** 화면 기준 0-based 페이지. 서버는 1부터 세므로 여기서 +1 한다. */
  page: number;
  size: number;
  /** **DB 컬럼명.** 화면 필드명(`createdAt`)이 아니다. */
  orderBy: string;
  order: "asc" | "desc";
  /** 이메일·이름 부분 일치. 빈 문자열이면 안 보낸다. */
  q: string;
  /** 등급. 빈 문자열이면 «전체», `none` 은 «등급 없음». */
  level: string;
  /** 멤버십 그룹 id. `null` 이면 «전체». */
  membershipId: number | null;
  /** 계정 상태. `null` 이면 «전체», `true` 활성 · `false` 비활성. */
  isActive: boolean | null;
};

export function buildAdminUsersQuery(input: AdminUsersQueryInput): string {
  const params = new URLSearchParams({
    page: String(input.page + 1),
    size: String(input.size),
    orderBy: input.orderBy,
    order: input.order,
  });

  // 빈 값은 **보내지 않는다.** `q=` 나 `level=` 이 빈 채로 실리면 서버가 «빈 문자열로
  // 걸러 달라» 는 요청으로 읽을 수 있고, 무엇보다 URL 이 매번 달라져서 캐시가 갈린다.
  const q = input.q.trim();
  if (q) params.set("q", q);
  if (input.level) params.set("level", input.level);
  if (input.membershipId !== null) params.set("membershipId", String(input.membershipId));
  if (input.isActive !== null) params.set("isActive", String(input.isActive));

  return params.toString();
}
